import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

import heroImg from "../../../Images/hero-villa.jpg";
import cityImg from "../../../Images/city-skyline.jpg";
import interiorImg from "../../../Images/apartment-interior.jpg";
import towerImg from "../../../Images/property-tower.jpg";

// import "./WinnersLand.css";

// function WinnersInsights() {
//   const [open, setOpen] = useState(0);

//   const insights = [
//     {
//       city: "Lucknow",
//       growth: "+14.2%",
//       avgPrice: "₹7,200/sqft",
//       roi: "12.5%",
//     },
//     {
//       city: "Gurgaon",
//       growth: "+18.6%",
//       avgPrice: "₹14,800/sqft",
//       roi: "16.1%",
//     },
//     {
//       city: "Noida Extension",
//       growth: "+22.4%",
//       avgPrice: "₹9,600/sqft",
//       roi: "19.8%",
//     },
//     {
//       city: "Dwarka",
//       growth: "+11.7%",
//       avgPrice: "₹12,400/sqft",
//       roi: "10.9%",
//     },
//   ];

//   return (
//     <section className="ws-insights">
//       <div className="ws-insights-inner">
//         <div className="ws-insights-head">
//           <span className="ws-section-eyebrow">
//             Prime locations & insights
//           </span>

//           <h2 className="ws-section-heading">
//             Explore premium real estate markets across India.
//           </h2>

//           <p>
//             Discover trending investment zones, city growth analytics and
//             immersive market highlights curated for future-ready investors.
//           </p>
//         </div>

//         <div className="ws-acc">
//           {insights.map((i, idx) => {
//             const isOpen = open === idx;

//             return (
//               <div
//                 className="ws-acc-item"
//                 key={i.city}
//                 data-open={isOpen}
//               >
//                 <button
//                   className="ws-acc-trigger"
//                   onClick={() => setOpen(isOpen ? null : idx)}
//                 >
//                   <div className="ws-acc-left">
//                     <div className="ws-acc-badge">
//                       {i.city.charAt(0)}
//                     </div>

//                     <div className="ws-acc-title">
//                       <h3>{i.city}</h3>
//                       <span>Real estate growth insights</span>
//                     </div>
//                   </div>

//                   <div className="ws-acc-icon">
//                     <ChevronDown size={18} />
//                   </div>
//                 </button>

//                 {isOpen && (
//                   <div className="ws-acc-body">
//                     <div className="ws-acc-grid">
//                       <div className="ws-acc-stat">
//                         <span>Annual growth</span>
//                         <strong>{i.growth}</strong>
//                       </div>

//                       <div className="ws-acc-stat">
//                         <span>Avg. price</span>
//                         <strong>{i.avgPrice}</strong>
//                       </div>

//                       <div className="ws-acc-stat">
//                         <span>Investor ROI</span>
//                         <strong>{i.roi}</strong>
//                       </div>
//                     </div>

//                     <div className="ws-acc-reels">
//                       {[towerImg, cityImg, interiorImg, heroImg].map(
//                         (img, k) => (
//                           <div
//                             key={k}
//                             className="ws-acc-reel"
//                             style={{
//                               backgroundImage: `url(${img})`,
//                               backgroundSize: "cover",
//                               backgroundPosition: "center",
//                             }}
//                           />
//                         )
//                       )}
//                     </div>
//                   </div>
//                 )}
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     </section>
//   );
// }

// export default WinnersInsights;


export function WinnersInsights() {
  const [open, setOpen] = useState(0);
  const insights = [
    { city: "Lucknow", growth: "+14.2%", avgPrice: "₹7,200/sqft", roi: "12.5%" },
    { city: "Gurgaon", growth: "+18.6%", avgPrice: "₹14,800/sqft", roi: "16.1%" },
    { city: "Noida Extension", growth: "+22.4%", avgPrice: "₹9,600/sqft", roi: "19.8%" },
    { city: "Dwarka", growth: "+11.7%", avgPrice: "₹12,400/sqft", roi: "10.9%" },
  ];

  return (
    <section className="ws-insights">
      <div className="ws-insights-inner">
        <div className="ws-insights-head">
          <span className="ws-section-eyebrow">Prime locations & insights</span>
          <h2 className="ws-section-heading">Explore premium real estate markets across India.</h2>
          <p>Discover trending investment zones, city growth analytics and immersive market
            highlights curated for future-ready investors.</p>
        </div>

        <div className="ws-acc">
          {insights.map((i, idx) => {
            const isOpen = open === idx;
            return (
              <div className="ws-acc-item" key={i.city} data-open={isOpen}>
                <button className="ws-acc-trigger" onClick={() => setOpen(isOpen ? null : idx)}>
                  <div className="ws-acc-left">
                    <div className="ws-acc-badge">{i.city.charAt(0)}</div>
                    <div className="ws-acc-title">
                      <h3>{i.city}</h3>
                      <span>Real estate growth insights</span>
                    </div>
                  </div>
                  <div className="ws-acc-icon"><ChevronDown size={18} /></div>
                </button>
                {isOpen && (
                  <div className="ws-acc-body">
                    <div className="ws-acc-grid">
                      <div className="ws-acc-stat"><span>Annual growth</span><strong>{i.growth}</strong></div>
                      <div className="ws-acc-stat"><span>Avg. price</span><strong>{i.avgPrice}</strong></div>
                      <div className="ws-acc-stat"><span>Investor ROI</span><strong>{i.roi}</strong></div>
                    </div>
                    <div className="ws-acc-reels">
                      {[towerImg, cityImg, interiorImg, heroImg].map((img, k) => (
                        <div className="ws-acc-reel" key={k} style={{ backgroundImage: `url(${img})`, backgroundSize: "cover", backgroundPosition: "center" }} />
                      ))}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
